// src/routes.ts

// pages

// other
import React from "react";
import HomePage from "./Pages/HomePage";
import LoginPage from "./Pages/LoginPage";
import LogoutPage from "./Pages/LogoutPage";
import PromoMatchesPage from "./Pages/PromoMatchesPage";
import AddPromoMatchPage from "./Pages/AddPromoMatchPage";
import PromoMatchStatsPage from "./Pages/PromoMatchStatsPage";
import PromoBannersPage from "./Pages/PromoBannersPage";
import AddPromoBannerPage from "./Pages/AddPromoBannerPage";
import PromoMatchesStatsPage from "./Pages/PromoMatchesStatsPage";
import EditConfigPage from "./Pages/EditConfigPage";
import PromoInterstitialSettingsPage from "./Pages/PromoInterstitialSettingsPage";
import PromoChainOffersPage from "./Pages/PromoChainOffersPage";
import TopMatchesPage from "./Pages/TopMatchesPage";
import FunnelsConfigPage from "./Pages/FunnelsConfigPage";
import AddFunnelPage from "./Pages/AddFunnelPage";
import FunnelLocalizationsPage from "./Pages/FunnelLocalizationsPage";
import AddFunnelLocalization from "./Pages/AddFunnelLocalization";
import OffersPage from "./Pages/OffersPage";
import DeleteMyAccountPage from "./Pages/DeleteMyAccountPage";
import AccountDeletionRequestsPage from "./Pages/AccountDeletionRequestsPage";
import ShopPage from "./Pages/ShopPage";
import AddShopItemPage from "./Pages/AddShopItemPage";
import EditVideoPlacementPage from "./Pages/EditVideoPlacementPage";
import VideoPlacementsPage from "./Pages/VideoPlacementsPage";
import HomeMatchAdsPage from "./Pages/HomeMatchAdsPage";
import VideoPlacementStatsPage from "./Pages/VideoPlacementStatsPage";
import VideoPlacementsStatsPage from "./Pages/VideoPlacementsStatsPage";
import UsersPage from "./Pages/UsersPage";
import UserPage from "./Pages/UserPage";
import SupportPage from "./Pages/SupportPage";
import MatchesPage from "./Pages/MatchesPage";
import MatchPage from "./Pages/MatchPage";
import MatchBriefsPage from "./Pages/MatchBriefsPage";
import RecalculationRequestsPage from "./Pages/RecalculationRequestsPage";
import DeleteMyAccountStatusPage from "./Pages/DeleteMyAccountStatusPage";
import AddHomeMatchAdPage from "./Pages/AddHomeMatchAdPage";
import ProviderVarietyInfoPage from "./Pages/ProviderVarietyInfoPage";
import PreliminaryResultsPage from "./Pages/PreliminaryResultsPage";
import CompetitionsPage from "./Pages/CompetitionsPage";
import AddCompetitionPage from "./Pages/AddCompetitionPage";
import SportsPage from "./Pages/SportsPage";
import VirtualSportsPage from "./Pages/VirtualSportsPage";
import VirtualSportsLeaguesPage from "./Pages/VirtualSportsLeaguesPage";
import VirtualSportsMatchesPage from "./Pages/VirtualSportsMatchesPage";
import VirtualSportsTeamsPage from "./Pages/VirtualSportsTeamsPage";
import VirtualSportsPlayersPage from "./Pages/VirtualSportsPlayersPage";
import LeagueCatalogPage from "./Pages/LeagueCatalogPage";
import FlashBetSportsPage from "./Pages/FlashBetSportsPage";
import FlashBetCategoriesPage from "./Pages/FlashBetCategoriesPage";
import FlashBetMatchesPage from "./Pages/FlashBetMatchesPage";
import FlashBetTasksPage from "./Pages/FlashBetTasksPage";
import QuestionTemplatesPage from "./Pages/QuestionTemplatesPage";
import FlashBetStatsOverview from "./Pages/FlashBetStatsOverview";
import HealthPage from "./Pages/HealthPage";
import ServerHealthPage from "./Pages/ServerHealthPage";
import ProviderTaskStatsPage from "./Pages/ProviderTaskStatsPage";
import AiOverviewPage from "./Pages/ai/AiOverviewPage";
import AiWorkflowsPage, { AiWorkflowEditPage } from "./Pages/ai/AiWorkflowsPage";
import AiWorkflowRunPage from "./Pages/ai/AiWorkflowRunPage";
import AiTasksPage from "./Pages/ai/AiTasksPage";
import AiTaskEditPage from "./Pages/ai/AiTaskEditPage";
import AiAgentsPage from "./Pages/ai/AiAgentsPage";
import AiAgentEditPage from "./Pages/ai/AiAgentEditPage";
import AiModelsPage from "./Pages/ai/AiModelsPage";
import AiMcpServersPage from "./Pages/ai/AiMcpServersPage";
import AiBudgetsPage from "./Pages/ai/AiBudgetsPage";
import AiUsagePage from "./Pages/ai/AiUsagePage";
import AiToolsPage from './Pages/ai/AiToolsPage';
import AiRunsPage from "./Pages/ai/AiRunsPage";
import AiConversationsPage from "./Pages/ai/AiConversationsPage";
import AiConversationPage from "./Pages/ai/AiConversationPage";
import AiRunPage from "./Pages/ai/AiRunPage";
import AiTaskExecutionsPage, { AiTaskExecutionPage } from "./Pages/ai/AiTaskExecutionsPage";
import TourMarketingPage from "./Pages/TourMarketingPage";
import OnboardingFunnelPage from "./Pages/OnboardingFunnelPage";
import OneClickBetSettingsPage from "./Pages/OneClickBetSettingsPage";
import VarietyBetRestrictionsPage from "./Pages/VarietyBetRestrictionsPage";
import VarietyVersionGatesPage from "./Pages/VarietyVersionGatesPage";
import FlashBetSettingsPage from "./Pages/FlashBetSettingsPage";
import AppUpdateSettingsPage from "./Pages/AppUpdateSettingsPage";
import DailyQuestsAdminPage from "./Pages/DailyQuestsAdminPage";
import DailyQuestTemplatePage from "./Pages/DailyQuestTemplatePage";
import HtmlTemplatesPage from "./Pages/HtmlTemplatesPage";
import AddHtmlTemplatePage from "./Pages/AddHtmlTemplatePage";
import UserTagsPage from "./Pages/UserTagsPage";
import CreateUserTagPage from "./Pages/CreateUserTagPage";
import WebGamesPage from "./Pages/WebGamesPage";
import WebGamePreviewPage from "./Pages/WebGamePreviewPage";
import PresentationCampaignsPage from "./Pages/PresentationCampaignsPage";
import PresentationScreenRegistryPage from "./Pages/PresentationScreenRegistryPage";
import InterstitialCampaignsPage from "./Pages/InterstitialCampaignsPage";
import InterstitialCampaignEditPage from "./Pages/InterstitialCampaignEditPage";
import InterstitialCampaignStatsPage from "./Pages/InterstitialCampaignStatsPage";
import RewardedPromptCampaignsPage from "./Pages/RewardedPromptCampaignsPage";
import RewardedPromptCampaignEditPage from "./Pages/RewardedPromptCampaignEditPage";
import RewardedPromptCampaignStatsPage from "./Pages/RewardedPromptCampaignStatsPage";
import PollsPage from './Pages/PollsPage';
import SubscriptionsPage from './Pages/SubscriptionsPage';
import SubscriptionOffersPage from './Pages/SubscriptionOffersPage';
import PollEditPage from './Pages/PollEditPage';
import PollStatsPage from './Pages/PollStatsPage';
import MarketingPushPage from './Pages/MarketingPushPage';
import MarketingPushStatsPage from './Pages/MarketingPushStatsPage';
import { Navigate } from 'react-router-dom';
import QuizConfigurationsPage from "./Pages/QuizConfigurationsPage";
import QuizzesPage from "./Pages/QuizzesPage";
import QuizConfigurationEditPage from "./Pages/QuizConfigurationEditPage";
import QuizTiersPage from "./Pages/QuizTiersPage";
import QuizBetTypesPage from "./Pages/QuizBetTypesPage";
import BattlesPage from "./Pages/BattlesPage";
import BattleStakeSettingsPage from "./Pages/BattleStakeSettingsPage";
import BattleAgentsPage from "./Pages/BattleAgentsPage";
import BattleAgentEditPage from "./Pages/BattleAgentEditPage";
import BattleAgentsHistoryPage from "./Pages/BattleAgentsHistoryPage";
import BattleAgentsStatsPage from "./Pages/BattleAgentsStatsPage";
import BattleAgentsBotsPage from "./Pages/BattleAgentsBotsPage";
import BattlePage from "./Pages/BattlePage";
import PrivateClubPage from "./Pages/PrivateClubPage";
import PrivateClubTemplateClubsPage from "./Pages/PrivateClubTemplateClubsPage";
import PrivateClubTemplatePlacedBetsPage from "./Pages/PrivateClubTemplatePlacedBetsPage";
import PrivateClubTemplatesPage from "./Pages/PrivateClubTemplatesPage";
import BetupFeedReviewPage from "./Pages/BetupFeedReviewPage";
import BetupFeedPostsPage from "./Pages/BetupFeedPostsPage";
import BetupFeedReportsPage from "./Pages/BetupFeedReportsPage";
import BetupFeedTopPlayersPage from "./Pages/BetupFeedTopPlayersPage";
import BetupFeedChannelsPage from "./Pages/BetupFeedChannelsPage";
import BetupFeedChannelSubscribersPage from "./Pages/BetupFeedChannelSubscribersPage";
import BetupFeedChannelPage from "./Pages/BetupFeedChannelPage";
import PublishingPage from "./Pages/PublishingPage";


export enum AuthorizationState {Authorized, Unauthorized, Any}
// interface
interface Route {
    key: string,
    title: string,
    path: string,
    enabled: boolean,
    presentOnNavBar : boolean,
    authType : AuthorizationState,
    component: JSX.Element
}

export const routes: Array<Route> = [
    {
        key: 'home-route',
        title: 'Statistics',
        path: '/',
        enabled: true,
        presentOnNavBar: true,
        component: <HomePage/>,
        authType : AuthorizationState.Authorized
    },
    {
        key: 'promo-matches',
        title: "1XBet promo",
        path: '/promo-matches',
        enabled: true,
        presentOnNavBar: true,
        component: <PromoMatchesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'promo-banners',
        title: "Promo banners",
        path: '/promo-banners',
        enabled: true,
        presentOnNavBar: false,
        component: <PromoBannersPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'top-matches',
        title: "TOP matches",
        path: '/top-matches',
        enabled: true,
        presentOnNavBar: false,
        component: <TopMatchesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'matches',
        title: "Matches",
        path: '/matches',
        enabled: true,
        presentOnNavBar: true,
        component: <MatchesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'match-preliminary-results',
        title: "Preliminary Bet Results",
        path: '/matches/preliminary-bet-results',
        enabled: true,
        presentOnNavBar: false,
        component: <PreliminaryResultsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'match-ai-predictions',
        title: "AI predictions",
        path: '/matches/ai-predictions',
        enabled: true,
        presentOnNavBar: false,
        component: <MatchBriefsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'match-details',
        title: "Match details",
        path: '/matches/:id',
        enabled: true,
        presentOnNavBar: false,
        component: <MatchPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'provider-variety-details',
        title: "Match details",
        path: '/provider/:source/varieties/:id',
        enabled: true,
        presentOnNavBar: false,
        component: <ProviderVarietyInfoPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'users',
        title: "Users",
        path: '/users',
        enabled: true,
        presentOnNavBar: true,
        component: <UsersPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'support',
        title: "Support",
        path: '/support',
        enabled: true,
        presentOnNavBar: true,
        component: <SupportPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'recalculations',
        title: "Recalculations",
        path: '/recalculations',
        enabled: true,
        presentOnNavBar: false,
        component: <RecalculationRequestsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'user-info',
        title: "User",
        path: '/users/:id',
        enabled: true,
        presentOnNavBar: false,
        component: <UserPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'user-private-club',
        title: "Private club",
        path: '/users/:userId/private-clubs/:clubId',
        enabled: true,
        presentOnNavBar: false,
        component: <PrivateClubPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'web-games',
        title: "Web Mini Games",
        path: '/web-games',
        enabled: true,
        presentOnNavBar: false,
        component: <WebGamesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'web-game-preview',
        title: "Web Game Preview",
        path: '/web-games/preview',
        enabled: true,
        presentOnNavBar: false,
        component: <WebGamePreviewPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'add-promo-match',
        title: "Create promo match",
        path: '/promo-matches/create',
        enabled: true,
        presentOnNavBar: false,
        component: <AddPromoMatchPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'add-promo-banner',
        title: "Create promo banner",
        path: '/promo-banners/create',
        enabled: true,
        presentOnNavBar: false,
        component: <AddPromoBannerPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'edit-promo-match',
        title: "Edit promo match",
        path: '/promo-matches/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <AddPromoMatchPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'edit-promo-banner',
        title: "Edit promo banner",
        path: '/promo-banners/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <AddPromoBannerPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'stats-promo-match',
        title: "Stats for promo match",
        path: '/promo-matches/:id/stats',
        enabled: true,
        presentOnNavBar: false,
        component: <PromoMatchStatsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'stats-promo-matches',
        title: "Stats for promo match",
        path: '/promo-matches/stats',
        enabled: true,
        presentOnNavBar: false,
        component: <PromoMatchesStatsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'promo-interstitial-settings',
        title: "Interstitial ads",
        path: '/promo/interstitial-settings',
        enabled: true,
        presentOnNavBar: false,
        component: <PromoInterstitialSettingsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'promo-chain-offers',
        title: "Chain Offers",
        path: '/promo/chain-offers',
        enabled: true,
        presentOnNavBar: false,
        component: <PromoChainOffersPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'config',
        title: "Edit promo config",
        path: '/promo-config',
        enabled: true,
        presentOnNavBar: false,
        component: <EditConfigPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'funnels',
        title: "Funnels",
        path: '/funnels',
        enabled: true,
        presentOnNavBar: true,
        component: <FunnelsConfigPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'offers',
        title: "Funnel offers",
        path: '/funnels/offers',
        enabled: true,
        presentOnNavBar: false,
        component: <OffersPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'funnel-localizations',
        title: "Funnel localizations",
        path: '/funnels/localizations',
        enabled: true,
        presentOnNavBar: false,
        component: <FunnelLocalizationsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'add-funnel-localizations',
        title: "Add Funnel localizations",
        path: '/funnels/localizations/create',
        enabled: true,
        presentOnNavBar: false,
        component: <AddFunnelLocalization/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'edit-funnel-localizations',
        title: "Edit Funnel localizations",
        path: '/funnels/localizations/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <AddFunnelLocalization/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'html-templates',
        title: "HTML Templates",
        path: '/funnels/html-templates',
        enabled: true,
        presentOnNavBar: false,
        component: <HtmlTemplatesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'add-html-template',
        title: "Add HTML Template",
        path: '/funnels/html-templates/create',
        enabled: true,
        presentOnNavBar: false,
        component: <AddHtmlTemplatePage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'edit-html-template',
        title: "Edit HTML Template",
        path: '/funnels/html-templates/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <AddHtmlTemplatePage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'add-funnel',
        title: "Create funnel",
        path: '/funnels/add',
        enabled: true,
        presentOnNavBar: false,
        component: <AddFunnelPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'edit-funnel',
        title: "Edit funnel",
        path: '/funnels/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <AddFunnelPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'login',
        title: 'Авторизация',
        path: '/login',
        enabled: true,
        presentOnNavBar: false,
        component: <LoginPage/>,
        authType : AuthorizationState.Unauthorized
    },
    {
        key: 'logout',
        title: 'Logout',
        path: '/logout',
        enabled: true,
        presentOnNavBar: false,
        component: <LogoutPage/>,
        authType : AuthorizationState.Any
    },
    {
        key: 'delete-my-account',
        title: 'Delete my account',
        path: '/delete-my-account',
        enabled: true,
        presentOnNavBar: false,
        component: <DeleteMyAccountPage/>,
        authType : AuthorizationState.Any
    },
    {
        key: 'delete-my-account-status',
        title: 'Delete my account',
        path: '/delete-my-account/:code/status',
        enabled: true,
        presentOnNavBar: false,
        component: <DeleteMyAccountStatusPage/>,
        authType : AuthorizationState.Any
    },
    {
        key: 'delete-account-requests',
        title: 'Accounts',
        path: '/delete-account-requests',
        enabled: true,
        presentOnNavBar: false,
        component: <AccountDeletionRequestsPage/>,
        authType : AuthorizationState.Authorized
    },
    {
        key:"shop",
        title:"Shop",
        path:"/shop",
        enabled:true,
        presentOnNavBar:true,
        component: <ShopPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-tour',
        title: 'Tour rewards',
        path: '/marketing/tour-rewards',
        enabled: true,
        presentOnNavBar: true,
        component: <TourMarketingPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-onboarding-funnel',
        title: 'Onboarding funnel',
        path: '/marketing/onboarding-funnel',
        enabled: true,
        presentOnNavBar: true,
        component: <OnboardingFunnelPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-user-tags',
        title: 'User Tags',
        path: '/marketing/user-tags',
        enabled: true,
        presentOnNavBar: true,
        component: <UserTagsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-user-tags-create',
        title: 'Create User Tag',
        path: '/marketing/user-tags/create',
        enabled: true,
        presentOnNavBar: false,
        component: <CreateUserTagPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-user-tags-edit',
        title: 'Edit User Tag',
        path: '/marketing/user-tags/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <CreateUserTagPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-one-click',
        title: 'Quick / one-click bet',
        path: '/marketing/one-click-bet-settings',
        enabled: true,
        presentOnNavBar: true,
        component: <OneClickBetSettingsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-variety-bet-restrictions',
        title: 'Variety bet restrictions',
        path: '/marketing/variety-bet-restrictions',
        enabled: true,
        presentOnNavBar: true,
        component: <VarietyBetRestrictionsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-variety-version-gates',
        title: 'Variety version gates',
        path: '/marketing/variety-version-gates',
        enabled: true,
        presentOnNavBar: true,
        component: <VarietyVersionGatesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-flash-bet',
        title: 'Flash Bet timing',
        path: '/marketing/flash-bet-settings',
        enabled: true,
        presentOnNavBar: true,
        component: <FlashBetSettingsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-app-update',
        title: 'App update',
        path: '/marketing/app-update-settings',
        enabled: true,
        presentOnNavBar: true,
        component: <AppUpdateSettingsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-daily-quests',
        title: 'Daily quests',
        path: '/marketing/daily-quests',
        enabled: true,
        presentOnNavBar: true,
        component: <DailyQuestsAdminPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-betup-feed-review',
        title: 'BETUP Feed review',
        path: '/marketing/betup-feed/review',
        enabled: true,
        presentOnNavBar: true,
        component: <BetupFeedReviewPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-betup-feed-posts',
        title: 'BETUP Feed posts',
        path: '/marketing/betup-feed/posts',
        enabled: true,
        presentOnNavBar: true,
        component: <BetupFeedPostsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-betup-feed-reports',
        title: 'BETUP Feed reports',
        path: '/marketing/betup-feed/reports',
        enabled: true,
        presentOnNavBar: true,
        component: <BetupFeedReportsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-betup-feed-top-players',
        title: 'BETUP Feed top players',
        path: '/marketing/betup-feed/top-players',
        enabled: true,
        presentOnNavBar: true,
        component: <BetupFeedTopPlayersPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-betup-feed-channels',
        title: 'BETUP Feed channels',
        path: '/marketing/betup-feed/channels',
        enabled: true,
        presentOnNavBar: true,
        component: <BetupFeedChannelsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-betup-feed-publishing',
        title: 'Publishing',
        path: '/marketing/betup-feed/publishing',
        enabled: true,
        presentOnNavBar: false,
        component: <PublishingPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-betup-feed-channel',
        title: 'BETUP Feed channel',
        path: '/marketing/betup-feed/channels/:id',
        enabled: true,
        presentOnNavBar: false,
        component: <BetupFeedChannelPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-betup-feed-channel-subscribers',
        title: 'BETUP Feed channel subscribers',
        path: '/marketing/betup-feed/channels/:id/subscribers',
        enabled: true,
        presentOnNavBar: false,
        component: <BetupFeedChannelSubscribersPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-presentations',
        title: 'Presentations',
        path: '/marketing/presentations',
        enabled: true,
        presentOnNavBar: true,
        component: <PresentationCampaignsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-interstitials',
        title: 'Custom interstitials',
        path: '/marketing/interstitials',
        enabled: true,
        presentOnNavBar: true,
        component: <InterstitialCampaignsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-interstitial-new',
        title: 'New interstitial campaign',
        path: '/marketing/interstitials/new',
        enabled: true,
        presentOnNavBar: false,
        component: <InterstitialCampaignEditPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-interstitial-edit',
        title: 'Edit interstitial campaign',
        path: '/marketing/interstitials/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <InterstitialCampaignEditPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-interstitial-stats',
        title: 'Interstitial stats',
        path: '/marketing/interstitials/:id/stats',
        enabled: true,
        presentOnNavBar: false,
        component: <InterstitialCampaignStatsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-rewarded-prompts',
        title: 'Rewarded video prompts',
        path: '/marketing/rewarded-prompts',
        enabled: true,
        presentOnNavBar: true,
        component: <RewardedPromptCampaignsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-rewarded-prompt-new',
        title: 'New rewarded video prompt',
        path: '/marketing/rewarded-prompts/new',
        enabled: true,
        presentOnNavBar: false,
        component: <RewardedPromptCampaignEditPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-rewarded-prompt-edit',
        title: 'Edit rewarded video prompt',
        path: '/marketing/rewarded-prompts/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <RewardedPromptCampaignEditPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-rewarded-prompt-stats',
        title: 'Rewarded prompt stats',
        path: '/marketing/rewarded-prompts/:id/stats',
        enabled: true,
        presentOnNavBar: false,
        component: <RewardedPromptCampaignStatsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-subscriptions',
        title: 'Subscriptions',
        path: '/marketing/subscriptions',
        enabled: true,
        presentOnNavBar: true,
        component: <SubscriptionsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-subscription-offers',
        title: 'Subscription offers',
        path: '/marketing/subscriptions/offers',
        enabled: true,
        presentOnNavBar: false,
        component: <SubscriptionOffersPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-polls',
        title: 'Polls',
        path: '/marketing/polls',
        enabled: true,
        presentOnNavBar: true,
        component: <PollsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-poll-new',
        title: 'New poll',
        path: '/marketing/polls/new',
        enabled: true,
        presentOnNavBar: false,
        component: <PollEditPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-poll-edit',
        title: 'Edit poll',
        path: '/marketing/polls/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <PollEditPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-poll-stats',
        title: 'Poll stats',
        path: '/marketing/polls/:id/stats',
        enabled: true,
        presentOnNavBar: false,
        component: <PollStatsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-push-notifications', title: 'Push notifications', path: '/marketing/push-notifications',
        enabled: true, presentOnNavBar: true, component: <MarketingPushPage/>, authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-push-stats', title: 'Push statistics', path: '/marketing/push-notifications/:id',
        enabled: true, presentOnNavBar: false, component: <MarketingPushStatsPage/>, authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-rate-app-redirect', title: 'Push notifications', path: '/marketing/rate-app',
        enabled: true, presentOnNavBar: false, component: <Navigate to="/marketing/push-notifications" replace/>, authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-presentation-screen-registry',
        title: 'Presentation screens',
        path: '/marketing/presentations/screen-registry',
        enabled: true,
        presentOnNavBar: true,
        component: <PresentationScreenRegistryPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-daily-quest-template-new',
        title: 'New daily quest template',
        path: '/marketing/daily-quests/templates/new',
        enabled: true,
        presentOnNavBar: false,
        component: <DailyQuestTemplatePage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'marketing-daily-quest-template-edit',
        title: 'Edit daily quest template',
        path: '/marketing/daily-quests/templates/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <DailyQuestTemplatePage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'edit-shop-item',
        title: "Edit shop item",
        path: '/shop-items/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <AddShopItemPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'create-shop-item',
        title: "Create shop item",
        path: '/shop-items/create',
        enabled: true,
        presentOnNavBar: false,
        component: <AddShopItemPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'video-placements',
        title: "Videos",
        path: '/video-placements',
        enabled: true,
        presentOnNavBar: true,
        component: <VideoPlacementsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'home-match-ads',
        title: "Match Ads",
        path: '/home-match-ads',
        enabled: true,
        presentOnNavBar: true,
        component: <HomeMatchAdsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'home-match-ads',
        title: "Edit Match Ad",
        path: '/home-match-ads/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <AddHomeMatchAdPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'home-match-ads',
        title: "Add Match Ad",
        path: '/home-match-ads/add',
        enabled: true,
        presentOnNavBar: false,
        component: <AddHomeMatchAdPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'edit-video-placement',
        title: "Edit video placement",
        path: '/video-placements/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <EditVideoPlacementPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'video-placement-stats',
        title: "Stats for video placement",
        path: '/video-placements/:id/stats',
        enabled: true,
        presentOnNavBar: false,
        component: <VideoPlacementStatsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'video-placements-stats',
        title: "Stats for video placement",
        path: '/video-placements/stats',
        enabled: true,
        presentOnNavBar: false,
        component: <VideoPlacementsStatsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'competitions',
        title: "Competitions",
        path: '/competitions',
        enabled: true,
        presentOnNavBar: true,
        component: <CompetitionsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'battles',
        title: "Battles",
        path: '/battles',
        enabled: true,
        presentOnNavBar: true,
        component: <BattlesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'battle-stake-settings',
        title: "Battle stake limits",
        path: '/battles/stake-settings',
        enabled: true,
        presentOnNavBar: true,
        component: <BattleStakeSettingsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'private-clubs',
        title: "Private club templates",
        path: '/private-clubs',
        enabled: true,
        presentOnNavBar: true,
        component: <PrivateClubTemplatesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'private-club-template-clubs',
        title: "Private clubs",
        path: '/private-clubs/templates/:templateId/clubs',
        enabled: true,
        presentOnNavBar: false,
        component: <PrivateClubTemplateClubsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'private-club-template-placed-bets',
        title: "Private club bets",
        path: '/private-clubs/templates/:templateId/placed-bets',
        enabled: true,
        presentOnNavBar: false,
        component: <PrivateClubTemplatePlacedBetsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'battle-agents',
        title: "Battle agents",
        path: '/battle-agents',
        enabled: true,
        presentOnNavBar: true,
        component: <BattleAgentsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'battle-agents-history',
        title: "Battle agent history",
        path: '/battle-agents/history',
        enabled: true,
        presentOnNavBar: false,
        component: <BattleAgentsHistoryPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'battle-agents-stats',
        title: "Battle agent stats",
        path: '/battle-agents/stats',
        enabled: true,
        presentOnNavBar: false,
        component: <BattleAgentsStatsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'battle-agents-bots',
        title: "Battle agent bots",
        path: '/battle-agents/bots',
        enabled: true,
        presentOnNavBar: false,
        component: <BattleAgentsBotsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'battle-agents-new',
        title: "New battle agent",
        path: '/battle-agents/new',
        enabled: true,
        presentOnNavBar: false,
        component: <BattleAgentEditPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'battle-agents-edit',
        title: "Edit battle agent",
        path: '/battle-agents/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <BattleAgentEditPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'battle-detail',
        title: "Battle details",
        path: '/battles/:id',
        enabled: true,
        presentOnNavBar: false,
        component: <BattlePage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'sports',
        title: "Sports",
        path: '/sports',
        enabled: true,
        presentOnNavBar: true,
        component: <SportsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'virtual-sports',
        title: "Virtual sports",
        path: '/virtual-sports',
        enabled: true,
        presentOnNavBar: true,
        component: <VirtualSportsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'virtual-sports-leagues',
        title: "Virtual leagues",
        path: '/virtual-sports/leagues',
        enabled: true,
        presentOnNavBar: false,
        component: <VirtualSportsLeaguesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'virtual-sports-matches',
        title: "Virtual matches",
        path: '/virtual-sports/matches',
        enabled: true,
        presentOnNavBar: false,
        component: <VirtualSportsMatchesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'virtual-sports-teams',
        title: "Virtual teams",
        path: '/virtual-sports/teams',
        enabled: true,
        presentOnNavBar: false,
        component: <VirtualSportsTeamsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'virtual-sports-players',
        title: "Virtual players",
        path: '/virtual-sports/players',
        enabled: true,
        presentOnNavBar: false,
        component: <VirtualSportsPlayersPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'league-catalog',
        title: "League catalog",
        path: '/league-catalog',
        enabled: true,
        presentOnNavBar: true,
        component: <LeagueCatalogPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'competitionEdit',
        title: "Edit Competition",
        path: '/competitions/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <AddCompetitionPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'competitionCreate',
        title: "Create Competition",
        path: '/competitions/create',
        enabled: true,
        presentOnNavBar: false,
        component: <AddCompetitionPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'quizzes',
        title: "Quizzes",
        path: '/quizzes',
        enabled: true,
        presentOnNavBar: true,
        component: <QuizzesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'quiz-configurations',
        title: "Quiz (sport & leagues)",
        path: '/quiz/configurations',
        enabled: true,
        presentOnNavBar: true,
        component: <QuizConfigurationsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'quiz-configuration-create',
        title: "Create Quiz Configuration",
        path: '/quiz/configurations/create',
        enabled: true,
        presentOnNavBar: false,
        component: <QuizConfigurationEditPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'quiz-configuration-edit',
        title: "Edit Quiz Configuration",
        path: '/quiz/configurations/:id/edit',
        enabled: true,
        presentOnNavBar: false,
        component: <QuizConfigurationEditPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'quiz-tiers',
        title: "Quiz Tiers",
        path: '/quiz/tiers',
        enabled: true,
        presentOnNavBar: false,
        component: <QuizTiersPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'quiz-bet-types',
        title: "Quiz Bet Types",
        path: '/quiz/bet-types',
        enabled: true,
        presentOnNavBar: false,
        component: <QuizBetTypesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'flashbet-sports',
        title: "FlashBet",
        path: '/flashbet/sports',
        enabled: true,
        presentOnNavBar: true,
        component: <FlashBetSportsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'flashbet-categories',
        title: "FlashBet Categories",
        path: '/flashbet/categories',
        enabled: true,
        presentOnNavBar: false,
        component: <FlashBetCategoriesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'flashbet-matches',
        title: "FlashBet Matches",
        path: '/flashbet/matches',
        enabled: true,
        presentOnNavBar: false,
        component: <FlashBetMatchesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'flashbet-questions',
        title: "FlashBet Questions",
        path: '/flashbet/questions',
        enabled: true,
        presentOnNavBar: true,
        component: <QuestionTemplatesPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'flashbet-tasks',
        title: "FlashBet Tasks",
        path: '/flashbet/tasks',
        enabled: true,
        presentOnNavBar: true,
        component: <FlashBetTasksPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'flashbet-stats',
        title: "FlashBet Statistics",
        path: '/flashbet/stats',
        enabled: true,
        presentOnNavBar: false,
        component: <FlashBetStatsOverview/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-overview',
        title: "AI",
        path: '/ai',
        enabled: true,
        presentOnNavBar: true,
        component: <AiOverviewPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-tasks',
        title: "AI tasks",
        path: '/ai/tasks',
        enabled: true,
        presentOnNavBar: true,
        component: <AiTasksPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-task-edit',
        title: "AI task",
        path: '/ai/tasks/:code',
        enabled: true,
        presentOnNavBar: false,
        component: <AiTaskEditPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-agents',
        title: "AI agents",
        path: '/ai/agents',
        enabled: true,
        presentOnNavBar: true,
        component: <AiAgentsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-agent-edit',
        title: "AI agent",
        path: '/ai/agents/:code',
        enabled: true,
        presentOnNavBar: false,
        component: <AiAgentEditPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-runs',
        title: "AI runs",
        path: '/ai/runs',
        enabled: true,
        presentOnNavBar: true,
        component: <AiRunsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-run-detail',
        title: "AI run",
        path: '/ai/runs/:runId',
        enabled: true,
        presentOnNavBar: false,
        component: <AiRunPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-task-executions',
        title: "AI task executions",
        path: '/ai/task-executions',
        enabled: true,
        presentOnNavBar: true,
        component: <AiTaskExecutionsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-task-execution-detail',
        title: "AI task execution",
        path: '/ai/task-executions/:executionId',
        enabled: true,
        presentOnNavBar: false,
        component: <AiTaskExecutionPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-conversations',
        title: "AI conversations",
        path: '/ai/conversations',
        enabled: true,
        presentOnNavBar: true,
        component: <AiConversationsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-conversation-support-chat',
        title: "AI conversation of a support chat",
        path: '/ai/conversations/support-chat/:chatId',
        enabled: true,
        presentOnNavBar: false,
        component: <AiConversationPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-conversation-detail',
        title: "AI conversation",
        path: '/ai/conversations/:conversationId',
        enabled: true,
        presentOnNavBar: false,
        component: <AiConversationPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-tools',
        title: "AI tool calls",
        path: '/ai/tools',
        enabled: true,
        presentOnNavBar: true,
        component: <AiToolsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-usage',
        title: "AI usage",
        path: '/ai/usage',
        enabled: true,
        presentOnNavBar: true,
        component: <AiUsagePage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-workflows',
        title: "AI workflows",
        path: '/ai/workflows',
        enabled: true,
        presentOnNavBar: true,
        component: <AiWorkflowsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-workflow',
        title: "AI workflow",
        path: '/ai/workflows/:code',
        enabled: true,
        presentOnNavBar: false,
        component: <AiWorkflowEditPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-workflow-run',
        title: "AI workflow run",
        path: '/ai/workflows/:code/runs/:runKey',
        enabled: true,
        presentOnNavBar: false,
        component: <AiWorkflowRunPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-budgets',
        title: "AI budgets",
        path: '/ai/budgets',
        enabled: true,
        presentOnNavBar: true,
        component: <AiBudgetsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-models',
        title: "AI models & keys",
        path: '/ai/models',
        enabled: true,
        presentOnNavBar: true,
        component: <AiModelsPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'ai-mcp-servers',
        title: "AI MCP servers",
        path: '/ai/mcp-servers',
        enabled: true,
        presentOnNavBar: true,
        component: <AiMcpServersPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'health',
        title: "Health",
        path: '/health',
        enabled: true,
        presentOnNavBar: true,
        component: <HealthPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'health-server-detail',
        title: "Server Health",
        path: '/health/servers/:serverId',
        enabled: true,
        presentOnNavBar: false,
        component: <ServerHealthPage/>,
        authType: AuthorizationState.Authorized
    },
    {
        key: 'health-provider-tasks',
        title: "Provider task history",
        path: '/health/provider-tasks',
        enabled: true,
        presentOnNavBar: false,
        component: <ProviderTaskStatsPage/>,
        authType: AuthorizationState.Authorized
    }
]
